import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

import { RouterLink, RouterPage } from 'APP/router/constants';
import { ProjectInstallationType } from 'CONFIG_TYPES';
import { checkIsCurrentInstallationType } from 'UTILS/checkIsCurrentInstallationType';

export type TAuthorizationRoutePath = RouterPage | '';

export type TAuthorizationRoute = Omit<RouteObject, 'index' | 'path'> & {
  isAvailable: boolean;
  link: RouterLink;
  index: boolean;
  path: TAuthorizationRoutePath;
};

const LoginPage = lazy(() =>
  import('APP/pages/authorization/Login/Login').then((imported) => ({ default: imported.Login }))
);

const LoginCreateAccountPage = lazy(() =>
  import('APP/pages/authorization/LoginCreateAccount/LoginCreateAccount').then((imported) => ({
    default: imported.LoginCreateAccount,
  }))
);

export const APP_LOGIN_ROUTE: TAuthorizationRoute = {
  index: true,
  isAvailable: true,
  link: RouterLink.Login,
  path: '',
  element: (
    <Suspense fallback={<div />}>
      <LoginPage isShowOtherOptions />
    </Suspense>
  ),
};

export const APP_LOGIN_CREATE_ACCOUNT_ROUTE: TAuthorizationRoute = {
  index: false,
  isAvailable: checkIsCurrentInstallationType([
    ProjectInstallationType.AllInOne,
    ProjectInstallationType.CloudOnly,
  ]),
  link: RouterLink.LoginCreateAccount,
  path: RouterPage.LoginCreateAccount,
  element: (
    <Suspense fallback={<div />}>
      <LoginCreateAccountPage />
    </Suspense>
  ),
};

export const APP_AUTHORIZATION_ROUTES: TAuthorizationRoute[] = [
  APP_LOGIN_ROUTE,
  APP_LOGIN_CREATE_ACCOUNT_ROUTE,
].filter((route) => route.isAvailable);

export const APP_AUTHORIZATION_INDEX_ROUTE = APP_LOGIN_ROUTE;

export const APP_AUTHORIZATION_ROUTES_FOR_ROUTER: RouteObject[] = APP_AUTHORIZATION_ROUTES.map(
  (route) => {
    const { index, element, path } = route;
    return {
      index,
      element,
      path,
    };
  }
);
